import moment from "moment";
import React from "react";
import formatDateDDMMYYYY from "../../../../Main/formatDate";

const InvoiceA5 = React.forwardRef((props, ref) => {
  const { values } = props;

  return (
    <div ref={ref} style={styles.container}>
      <div className="text-regular text-xs pb-6">
        <div className="flex justify-between">
          <div>
            <table>
              <tbody>
                <tr className="">
                  <td>Customer</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {values?.customer?.name
                      ? values?.customer?.name
                      : "Walk-in-customer"}
                  </td>
                </tr>
                <tr>
                  <td>Phone</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {values?.customer?.phone ? values?.customer?.phone : ""}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>Invoice No</td>
                  <td className="px-2">:</td>
                  <td className="text-right">#INV-{values?.number}</td>
                </tr>
                <tr>
                  <td>Date</td>
                  <td className="px-2">:</td>
                  <td className="text-right">
                    {formatDateDDMMYYYY(values?.date)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <table style={styles.table}>
        <thead>
          <tr className="px-[0.1]" style={styles.tableHeader}>
            <th className="text-xs font-normal" style={styles.tableCell}>
              S.No
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Description
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Units
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Quantity
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Price
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Tax
            </th>
            <th className="text-xs font-normal" style={styles.tableCell}>
              Total
            </th>
          </tr>
        </thead>
        <tbody className="text-regular">
          {values?.details?.map((item, index) => (
            <tr className="text-xs" key={index}>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {index + 1}
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                <div>{item?.name}</div>
                <div>
                  {item?.description?.number
                    ? `#BATCH : ${item?.description?.number}`
                    : ""}
                </div>
                <div>
                  {item?.description?.expiry_date
                    ? `EXPIRY : ${formatDateDDMMYYYY(
                        item?.description?.expiry_date
                      )}`
                    : ""}
                </div>
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {item?.unit_name}
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {item?.quantity}
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {item?.sale_price?.toFixed(3)}
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {item?.tax_amount?.toFixed(3)}
              </td>
              <td className="text-xs p-[0.1px]" style={styles.tableCell}>
                {item?.total?.toFixed(3)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="text-regular">
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="6"
              align="right"
            >
              Subtotal
            </td>
            <td style={styles.tableCell}>{values?.subtotal?.toFixed(3)}</td>
          </tr>
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="6"
              align="right"
            >
              Tax [VAT]
            </td>
            <td style={styles.tableCell}>{values?.taxamount?.toFixed(3)}</td>
          </tr>
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="6"
              align="right"
            >
              Discount
            </td>
            <td style={styles.tableCell}>{values?.discount?.toFixed(3)}</td>
          </tr>
          {/* <tr style={styles.totalRow}>
            <td
              className="text-regular text-gray-700 text-medium text-xs"
              style={styles.tableCell}
              colSpan="5"
              align="right"
            >
              Delivery
            </td>
            <td style={styles.tableCell}>{values?.discount?.toFixed(3)}</td>
          </tr> */}
          <tr style={styles.totalRow}>
            <td
              className="text-regular text-medium text-xs"
              style={styles.tableCell}
              colSpan="6"
              align="right"
            >
              Total
            </td>
            <td
              className="text-regular text-medium text-xs"
              style={styles.tableCell}
            >
              {values?.total?.toFixed(3)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

const styles = {
  container: {
    width: "210mm", // A5 width
    height: "148mm", // A5 height
    padding: "38mm 20mm", // Adjust padding to avoid pre-printed header/footer
    fontFamily: "Arial, sans-serif",
    fontSize: "12px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
  },
  tableCell: {
    // border: "1px solid #000",
    padding: "8px",
    textAlign: "left",
  },
  totalRow: {
    fontWeight: "normal",
  },
  billingvalues: {
    marginBottom: "20px",
  },
};

export default InvoiceA5;
